import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    const showCsat = urlParams.get('show_csat')
    
    if (showCsat) {
      const modal = document.querySelector(`#csat-deliverable-modal-${showCsat}`)
      if (modal) {
        $(modal).modal('show')
        window.history.replaceState({}, '', window.location.pathname)
      }
    }
  }
}